module.exports = __webpack_public_path__ + "img/step16.fde55694.png";